import { PaymentTransactionDto } from './payment-transaction-dto';

export class PaymentTransactionAchDto extends PaymentTransactionDto {
  constructor(public referenceNumber: string, paymentDate: Date, paymentMethodId: number) {
    super(paymentDate, paymentMethodId);
  }
}
